import { Injectable } from '@rxdi/core';

@Injectable()
export class ParsersProvider {
  parseUniqueId(uniqueLabel = '') {
    return uniqueLabel.split('_')[0];
  }

  parseUserId(uniqueLabel = '') {
    return uniqueLabel.split('_')[1];
  }

  parseLabel(uniqueLabel = '') {
    return uniqueLabel.split('_')[2];
  }
}
